export enum HighlightTechdataKeys {
  PREUSE_DETAIL = 'PreuseDetail',
  GEAR_BOX = 'GearBox',
  FUEL_TYPE = 'FuelType',
  INITIAL_REGISTRATION_DATE = 'InitialRegistrationDate',
  ELECTRIC_RANGE = 'ElectricRange',
  EXT_COLOR = 'ExtColor',
}

export interface HighLightItem {
  IconLabel?: string;
  TechdataKey: WarrantyNameTypes | HighlightTechdataKeys | string;
  InfoLink?: string;
}

export interface DetailHighlightsData {
  HighlightIcons: HighLightItem[];
}

export const warrantyCodeLookup = {
  WarrantyTypeNap: 'used-car-warranty-type.NAP',
  Warranty: 'used-car-warranty-type.warranty',
  WarrantyTypeWarranty: 'used-car-warranty-type.warranty',
  WarrantyTypePlus: 'used-car-warranty-type.plus',
  WarrantyType5Years: 'used-car-warranty-type.5-years',
  WarrantyTypeAsgExtended: 'used-car-warranty-type.asg-extended',
  WarrantyTypeAsg: 'used-car-warranty-type.asg',
  WarrantyTypeGwb: 'used-car-warranty-type.gwplus5-years-extended',
  WarrantyType12Months: 'used-car-warranty-type.twelve-months',
  WarrantyTypeClp: 'used-car-warranty-type.clp',
  WarrantyTypeCpo: 'used-car-warranty-type.cpo',
};

export type WarrantyNameTypes = keyof typeof warrantyCodeLookup;
